import React from "react";
import { ProjectCarousel } from "./ProjectDetailPage";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const shortsVideoIds = [
  "76auVrTjMmU",
  "KGOVXvQJb9M",
  "ZymY02F-X18",
  "dwkVNwyBGPQ",
  "oKmT7wZgukM",
  "9-J-FibfRiA",
  "gOhFgeS_E50",
  "5na_GCiNyTU",
  "XCLTSQAjGz4",
  "BaBGE6gcAMI",
];

const YouTubeShortEmbed = ({ videoId }) => {
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
  return (
    <iframe
      className="w-full aspect-[9/16] border-0 rounded-lg shadow-lg"
      src={embedUrl}
      title={`YouTube video player - Short ${videoId}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      loading="lazy"
    ></iframe>
  );
};

export const Trainings = () => {
  const trainerImages = [
    "/images/trainers/train7.jpg",
    "/images/trainers/train8.jpeg",
    "/images/trainers/train9.jpg",
    "/images/trainers/train10.jpg",
    "/images/trainers/train11.jpeg",
    "/images/trainers/train12.jpg",
    "/images/trainers/train13.jpg",
    "/images/trainers/train1.jpeg",
    "/images/trainers/train2.jpeg",
    "/images/trainers/train3.jpeg",
    "/images/trainers/train4.jpeg",
    "/images/trainers/train5.jpeg",
    "/images/trainers/train6.jpeg",
  ];

  return (
    <div className="flex flex-col w-full font-montserrat md:px-0 px-6 sm:px-10">
      <div id="testimonials" className="flex flex-col w-full mt-12 py-12 md:py-16 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8 md:mb-12">
          Отзывы слушателей
        </h2>
        <div className="w-full">
          <Swiper
            modules={[Navigation, Pagination, A11y]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
          >
            {shortsVideoIds.map((videoId) => (
              <SwiperSlide key={videoId}>
                <YouTubeShortEmbed videoId={videoId} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div
        id="trainers"
        className="flex md:flex-row w-full items-center flex-col pt-12 pb-12 md:pt-16 md:pb-16 lg:pt-20 lg:pb-20 gap-8 md:gap-12 max-w-6xl mx-auto"
      >
        <div className="md:w-1/2 w-full max-w-2xl">
          <h3 className="mb-6 font-bold text-3xl">Наши тренеры</h3>
          <ul className="space-y-2 list-disc list-outside pl-5">
            <li className="text-gray-600 text-sm">
              Лучшие отечественные эксперты и учителя
            </li>
            <li className="text-gray-600 text-sm">
              Разработчики нормативно-правовых актов в сфере образования РК
            </li>
            <li className="text-gray-600 text-sm">
              Ассоциированные профессоры ведущих ВУЗов
            </li>
            <li className="text-gray-600 text-sm">
              Учителя лицеев «Білім-Инновация» и профессоры университета SDU
            </li>
            <li className="text-gray-600 text-sm">
              Ведущие международные эксперты из Австралии, Великобритании,
              Венгрии, Германии, Италии, Китая, Малайзии, Польши, Сингапура,
              Финляндии, Швеции и других стран
            </li>
            <li className="text-gray-600 text-sm">
              Специалисты «Института раннего развития детей» Министерства
              просвещения РК
            </li>
            <li className="text-gray-600 text-sm">
              Основатели лучших зарубежных дошкольных организаций и другие
            </li>
          </ul>
        </div>

        <div className="md:w-1/2 w-full">
          <ProjectCarousel
            images={trainerImages}
            autoplayDelay={4000}
          />
        </div>
      </div>
    </div>
  );
};

export default Trainings;
